import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { ArrowRight, Calendar, Clock } from "lucide-react";

export const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      slug: "how-bopp-tape-is-manufactured",
      title: "How BOPP Tape is Manufactured - Complete Guide 2025",
      excerpt: "Comprehensive guide to BOPP tape manufacturing process, from coating to slitting. Learn about machinery, materials, and production techniques.",
      image: "data:image/svg+xml,%3Csvg width='800' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='800' height='400' fill='%23F59E0B'/%3E%3C/svg%3E",
      date: "January 10, 2025",
      readTime: "12 min read",
      category: "Manufacturing Process"
    },
    {
      id: 2,
      slug: "types-of-coating-machines",
      title: "Types of Coating Machines for Packaging Industry",
      excerpt: "Detailed comparison of hot melt, solvent-based, and water-based coating machines. Which one is right for your business?",
      image: "data:image/svg+xml,%3Csvg width='800' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='800' height='400' fill='%23D97706'/%3E%3C/svg%3E",
      date: "January 9, 2025",
      readTime: "10 min read",
      category: "Equipment Guide"
    },
    {
      id: 3,
      slug: "cost-of-tape-manufacturing-plant",
      title: "Cost of Starting a Tape Manufacturing Plant in India 2025",
      excerpt: "Complete breakdown of investment required for BOPP tape manufacturing plant including machinery, infrastructure, and operational costs.",
      image: "data:image/svg+xml,%3Csvg width='800' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='800' height='400' fill='%23B45309'/%3E%3C/svg%3E",
      date: "January 8, 2025",
      readTime: "15 min read",
      category: "Business Planning"
    }
  ];

  return (
    <>
      <Helmet>
        <title>BOPP Tape Manufacturing Blog - Expert Guides & Industry Insights | Hero Impex</title>
        <meta name="description" content="Expert guides on BOPP tape manufacturing, coating machines, slitting equipment. Learn from 45+ years of industry experience. Updated 2025." />
        <meta name="keywords" content="BOPP tape manufacturing, coating machine guide, tape plant setup, manufacturing process, industry insights" />
      </Helmet>

      <div className="min-h-screen bg-slate-50">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl">
              <Badge className="mb-4 bg-amber-500 text-white">Industry Insights</Badge>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Manufacturing Knowledge Hub
              </h1>
              <p className="text-xl text-slate-300">
                Expert guides, industry insights, and technical knowledge from 45+ years of manufacturing excellence in coating and converting machinery.
              </p>
            </div>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <Link key={post.id} to={`/blog/${post.slug}`}>
                  <Card className="h-full hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] border-2 border-amber-100">
                    <div className="aspect-video bg-gradient-to-br from-amber-400 to-amber-600 overflow-hidden">
                      <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
                    </div>
                    <CardContent className="p-6">
                      <Badge className="mb-3 bg-amber-100 text-amber-700">{post.category}</Badge>
                      <h3 className="text-xl font-bold text-slate-900 mb-3 line-clamp-2">
                        {post.title}
                      </h3>
                      <p className="text-slate-600 mb-4 line-clamp-3">
                        {post.excerpt}
                      </p>
                      <div className="flex items-center gap-4 text-sm text-slate-500">
                        <div className="flex items-center gap-1">
                          <Calendar className="w-4 h-4" />
                          <span>{post.date}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <Clock className="w-4 h-4" />
                          <span>{post.readTime}</span>
                        </div>
                      </div>
                      <div className="mt-4 text-amber-600 font-semibold flex items-center gap-2">
                        Read Article <ArrowRight className="w-4 h-4" />
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
